import { cardsItems } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              深度爆料
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              网红圈重大事件深度报道，每篇都有料
            </p>
          </div>

          <div className="space-y-5 md:space-y-6">
            {cardsItems.map((item, i) => (
              <div
                key={item.id}
                className="flex flex-col md:flex-row gap-5 md:gap-6 bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-200 cursor-pointer group"
              >
                <div className="w-full md:w-64 lg:w-72 flex-shrink-0">
                  <div className="w-full aspect-[16/10] md:aspect-auto md:h-full overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                    />
                  </div>
                </div>
                <div className="flex-1 p-5 md:p-6 md:pl-0">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="inline-block px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                      {item.badge}
                    </span>
                  </div>
                  <h3 className="text-base md:text-lg font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">
                    {item.desc}
                  </p>
                  <span className="inline-flex items-center gap-1 mt-4 text-sm text-primary-500 font-medium">
                    阅读全文
                    <i className="ri-arrow-right-line text-base"></i>
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}